import PropTypes                from 'prop-types';
import React                    from 'react';
import { connect }              from 'react-redux';
import Notification             from '../API/notifications';
import Slider                   from '../components/Slider';
import GetPromoCode             from '../components/GetPromoCode';
import { IMaskInput }           from 'react-imask';
import { stopEvent, ymElem }    from '../utils/helpers';
import { trackEvent }                       from '../utils/tracking'

class App extends React.PureComponent {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            contactPhone: '',
            successed: false
        };
    }

    componentDidMount() {

    }

    setPhone = (value) => {
        const { contactPhone } = this.state;
        if(contactPhone !== value) this.setState({ contactPhone: value });
    };

    sentLink = async (event) => {
        stopEvent(event);
        trackEvent('promo_share_sms_app');
        const { contactPhone } = this.state;
        let data = await Notification.sendLinkApp(contactPhone);

        if(data.success) {
            this.setState({ successed: true });
        }
    };

    render() {
        const { lang } = this.props;

        let formLink = (
            <div className="input-block row">
                <div className="form-group col-8">
                    <IMaskInput
                        mask='+{7} (000) 000 00 00'
                        unmask={true}
                        className="form-control"
                        onAccept={
                            (value, mask) => {
                                this.setPhone(value);
                            }
                        }
                        placeholder={lang.PhoneNumber1}
                        value={this.state.contactPhone || ''}
                    />
                </div>
                <div className="form-group col-4">
                    <button type="button" onClick={this.sentLink} className="btn btn-block btn-primary">{lang.SendTo}</button>
                </div>
            </div>
        );

        let successed = (
            <div style={{color: 'green', marginTop: 20 + 'px'}}>{lang.PageApp_slider_4_send2}</div>
        );

        const data = [{
            id: 0,
            elem: (
                <div className="row">
                    <div className="col-sm">
                        <div className="content">
                            <div className="icon">
                                <div className="img-icon badge-1"/>
                            </div>
                            <div className="title">{lang.PageApp_slider_1_title}</div>
                            <div className="desc">{lang.PageApp_slider_1_desc}</div>
                            <div className="row bages">
                                <div className="col-sm">
                                    <div className="bage">{lang.PageApp_slider_1_bage_1}</div>
                                    <div className="bage">{lang.PageApp_slider_1_bage_2}</div>
                                </div>
                                <div className="col-sm">
                                    <div className="bage">{lang.PageApp_slider_1_bage_3}</div>
                                    <div className="bage">{lang.PageApp_slider_1_bage_4}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm">
                        <div className="mobile">
                            <div className="iphone slide-0"/>
                        </div>
                    </div>
                </div>
            )
        }, {
            id: 1,
            elem: (
                <div className="row">
                    <div className="col-sm">
                        <div className="content">
                            <div className="icon">
								<div className="img-icon badge-2"/>
                            </div>
                            <div className="title">{lang.PageApp_slider_2_title}</div>
                            <div className="desc">{lang.PageApp_slider_2_desc}</div>
                            <div className="row bages">
                                <div className="col-sm">
                                    <div className="bage">{lang.PageApp_slider_2_bage_1}</div>
                                    <div className="bage">{lang.PageApp_slider_2_bage_3}</div>
                                </div>
                                <div className="col-sm">
                                    <div className="bage">{lang.PageApp_slider_2_bage_2}</div>
                                    <div className="bage">{lang.PageApp_slider_2_bage_4}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm">
                        <div className="mobile">
                            <div className="iphone slide-1"/>
                        </div>
                    </div>
                </div>
            )
        }, {
            id: 2,
            elem: (
                <div className="row">
                    <div className="col-sm">
                        <div className="content">
                            <div className="icon">
								<div className="img-icon badge-3"/>
                            </div>
                            <div className="title">{lang.PageApp_slider_3_title}</div>
                            <div className="desc">{lang.PageApp_slider_3_desc}</div>
                            <div className="row bages">
                                <div className="col-sm">
                                    <div className="bage">{lang.PageApp_slider_3_bage_1}</div>
                                </div>
                                <div className="col-sm">
                                    <div className="bage">{lang.PageApp_slider_3_bage_2}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm">
                        <div className="mobile">
                            <div className="iphone slide-2"/>
                        </div>
                    </div>
                </div>
            )
        }, {
            id: 3,
            elem: (
                <div className="row">
                    <div className="col-sm">
                        <div className="box-modal">
                            <div className="content">
                                <div className="icon">
									<div className="img-icon badge-4"/>
                                </div>
                                <div className="title">{lang.PageApp_slider_4_title}</div>
                                <div className="desc">{lang.PageApp_slider_4_desc}</div>

                                {this.state.successed ? successed : formLink}

                                <div className="download-app-wrap">
                                    <a href="https://goo.gl/Wl8y0C" target='_blank' className="download-app download-app-apple" onClick={() => ymElem('extLink', 'https://apps.apple.com/ru/app/mover-грузовое-такси/id1080999192')} />
                                    <a href="https://apps.apple.com/ru/app/mover-грузовое-такси/id1080999192" target='_blank' className="download-app download-app-google" onClick={() => ymElem('extLink', 'https://goo.gl/Wl8y0C')} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm">
                        <div className="mobile">
                            <div className="iphone slide-3"/>
                        </div>
                    </div>
                </div>
            )
        }];


        return (
            <div key="PageApp" className="page-wrap">
                <div className="page PageApp">
                    <div id="section-1" className="section-1 iphone">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm">
                                    <div className="s-title">{lang.PageApp_first_slide_title}</div>
                                    <div className="desc">{lang.PageApp_first_slide_desc}</div>
                                    <div className="links">
                                        <div className="link-info">{lang.PageApp_first_slide_links1}</div>  •
                                        <div className="link-info">{lang.PageApp_first_slide_links2}</div>  •<br />
                                        <div className="link-info">{lang.PageApp_first_slide_links3}</div>  •
                                        <div className="link-info">{lang.PageApp_first_slide_links4}</div>
                                    </div>
                                    <div className="download-app-wrap">
                                        <a href="https://apps.apple.com/ru/app/mover-грузовое-такси/id1080999192" target='_blank' className="download-app download-app-google" onClick={() => ymElem('extLink', 'https://goo.gl/Wl8y0C')} />
                                        <a href="https://goo.gl/Wl8y0C" target='_blank' className="download-app download-app-apple" onClick={() => ymElem('extLink', 'https://apps.apple.com/ru/app/mover-грузовое-такси/id1080999192')} />
                                    </div>
                                </div>
                                <div className="col-sm"/>
                            </div>
                        </div>
                    </div>

                    <div className="section-2">
                        <div className="container">
                            <div className="s-title">{lang.PageApp_second_slide_title}</div>

                            <div className="row what-doing">
                                <div className="col-sm circle">
                                    <div className="num">1</div>
                                    <div className="title">{lang.PageApp_second_slide_circle_1_title}</div>
                                    <div className="info" dangerouslySetInnerHTML={{__html: lang.PageApp_second_slide_circle_1_info}}/>
                                </div>
                                <div className="col-sm circle">
                                    <div className="num">2</div>
                                    <div className="title">{lang.PageApp_second_slide_circle_2_title}</div>
                                    <div className="info">{lang.PageApp_second_slide_circle_2_info}</div>
                                </div>
                                <div className="col-sm circle">
                                    <div className="num">3</div>
                                    <div className="title">{lang.PageApp_second_slide_circle_3_title}</div>
                                    <div className="info">{lang.PageApp_second_slide_circle_3_info}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="page">
                    <div className="section-3">
                        <Slider id='1' data={data} />
                    </div>

                    <div id="section-5" className="section-5">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm">
                                    <div className="content">
                                        <div className="s-title">{lang.PageApp_fourth_slide_title}</div>
                                        <div className="desc">{lang.PageApp_fourth_slide_desc}</div>

                                        <div className="download-app-wrap">
                                            <a href="https://itunes.apple.com/us/app/mover-%D0%B2%D0%BE%D0%B4%D0%B8%D1%82%D0%B5%D0%BB%D1%8C/id1403033643?mt=8" target='_blank' className="download-app download-app-google" onClick={() => ymElem('extLink', 'https://play.google.com/store/apps/details?id=ru.mover24.driver')} />
                                            <a href="https://play.google.com/store/apps/details?id=ru.mover24.driver" target='_blank' className="download-app download-app-apple" onClick={() => ymElem('extLink', 'https://itunes.apple.com/us/app/mover-%D0%B2%D0%BE%D0%B4%D0%B8%D1%82%D0%B5%D0%BB%D1%8C/id1403033643?mt=8')} />
                                        </div>

                                        <div className="items">
                                            <div className="row item">
                                                <div className="col-2 bage t-1"/>
                                                <div className="col-sm info">
                                                    <div className="title">{lang.PageApp_fourth_slide_item_1_title}</div>
                                                    <div className="desc">{lang.PageApp_fourth_slide_item_1_desc}</div>
                                                </div>
                                            </div>

                                            <div className="row item">
                                                <div className="col-2 bage t-2"/>
                                                <div className="col-sm info">
                                                    <div className="title">{lang.PageApp_fourth_slide_item_2_title}</div>
                                                    <div className="desc">{lang.PageApp_fourth_slide_item_2_desc}</div>
                                                </div>
                                            </div>

                                            <div className="row item">
                                                <div className="col-2 bage t-3"/>
                                                <div className="col-sm info">
                                                    <div className="title">{lang.PageApp_fourth_slide_item_3_title}</div>
                                                    <div className="desc">{lang.PageApp_fourth_slide_item_3_desc}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm">
                                    <div className="mobile">
                                        <div className="iphone"/>
                                    </div>
                                </div>
                            </div>
                            <div className="row big-bages">
                                <div className="col-sm">
                                    <div className="bage flash"/>
                                    <div className="title">{lang.PageApp_fourth_slide_flash_title}</div>
                                    <div className="desc">{lang.PageApp_fourth_slide_flash_desc}</div>
                                </div>
                                <div className="col-sm">
                                    <div className="bage shield"/>
                                    <div className="title">{lang.PageApp_fourth_slide_shield_title}</div>
                                    <div className="desc">{lang.PageApp_fourth_slide_shield_desc}</div>
                                </div>
                                <div className="col-sm">
                                    <div className="bage simple"/>
                                    <div className="title">{lang.PageApp_fourth_slide_simple_title}</div>
                                    <div className="desc">{lang.PageApp_fourth_slide_simple_desc}</div>
                                </div>
                            </div>

                            <div className="map"/>
                        </div>
                    </div>

                    <GetPromoCode lang={lang} />
                </div>
            </div>
        );
    }
}

const mapState = state => ({
    lang: state.lang
});

export default connect(mapState)(App);
